import { createSlice } from "@reduxjs/toolkit";
import { getFromServerTopic } from "../utility/slice";

const SLICE = "energyStar";
/*
const action = (name) => {
    return `${SLICE}/${name}`;
};*/

export const getCustomerMapping = getFromServerTopic({
  topic: SLICE,
  action: "findCustomersByStatusAndOrganization",
  // contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const getPropertyMappingBySiteId = getFromServerTopic({
  topic: SLICE,
  action: "findPropertyMappingBySiteId",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const getMetersByPropertyId = getFromServerTopic({
  topic: SLICE,
  action: "getMetersByPropertyId",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const getUnMappedDatapointsBySiteId = getFromServerTopic({
  topic: SLICE,
  action: "findUnMappedDatapointsBySiteId",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const getDatapointsMetersBySiteId = getFromServerTopic({
  topic: SLICE,
  action: "findDatapointsMetersBySiteId",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const getSiteInfo = getFromServerTopic({
  topic: SLICE,
  action: "findSiteMetricsInfo",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const getPropertyMappingRequests = getFromServerTopic({
  topic: SLICE,
  action: "findPropertyByStatusAndOrganization",
  // contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const getMeterMapping = getFromServerTopic({
  topic: SLICE,
  action: "findMetersByStatusAndOrganization",
  // contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const getDisconnectNotifications = getFromServerTopic({
  topic: SLICE,
  action: "getDisconnectNotifications",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const getConnectionSharingRequests = getFromServerTopic({
  topic: SLICE,
  action: "getConnectionSharingRequests",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const manageContactRequest = getFromServerTopic({
  topic: SLICE,
  action: "manageContactRequest",
  payloadFn: async (payload) => payload,
});

export const manageMeterRequest = getFromServerTopic({
  topic: SLICE,
  action: "manageMeterRequest",
  payloadFn: async (payload) => payload,
});

export const managePropertyRequest = getFromServerTopic({
  topic: SLICE,
  action: "managePropertyRequest",
  payloadFn: async (payload) => payload,
});

export const getHistoricDateOption = getFromServerTopic({
  topic: SLICE,
  action: "getHistoricDateOption",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});
export const uploadUsage = getFromServerTopic({
  topic: SLICE,
  action: "uploadUsage",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const processConnectionSharingJob = getFromServerTopic({
  topic: SLICE,
  action: "processConnectionSharingJob",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const processDisconnectNotificationsJob = getFromServerTopic({
  topic: SLICE,
  action: "processDisconnectNotificationsJob",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const refreshScoresForSite = getFromServerTopic({
  topic: SLICE,
  action: "refreshScoresForSite",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const refreshScoresForAll = getFromServerTopic({
  topic: SLICE,
  action: "refreshScoresForAll",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const uploadUsageBuilding = getFromServerTopic({
  topic: SLICE,
  action: "uploadUsageBuilding",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const uploadUsageAllMeters = getFromServerTopic({
  topic: SLICE,
  action: "uploadUsageAllMeters",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const updateMeterDatapoint = getFromServerTopic({
  topic: SLICE,
  action: "updateMeterDatapoint",
  //contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const addNewMeter = getFromServerTopic({
  topic: SLICE,
  action: "addNewMeter",
  //contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const removeWriteableMeter = getFromServerTopic({
  topic: SLICE,
  action: "removeWriteableMeter",
  //contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const removeReadOnlyMeter = getFromServerTopic({
  topic: SLICE,
  action: "removeReadOnlyMeter",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const getAdminAuditLog = getFromServerTopic({
  topic: SLICE,
  action: "getAdminAuditLog",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const getAuditLogBySite = getFromServerTopic({
  topic: SLICE,
  action: "getAuditLogBySite",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const getActiveSites = getFromServerTopic({
  topic: SLICE,
  action: "getActiveSites",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const getAccountsBySiteId = getFromServerTopic({
  topic: SLICE,
  action: "getAccountsBySiteId",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const updateUseUtilityBills = getFromServerTopic({
  topic: SLICE,
  action: "updateUseUtilityBills",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const slice = createSlice({
  name: SLICE,
  initialState: {
    customerMapping: [],
    propertyMapping: {},
    propertyRequests: [],
    meterMapping: [],
  },
  reducer: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerMapping.fulfilled, (state, action) => {
        state.customerMapping = [...action.payload.response];
      })
      .addCase(getPropertyMappingBySiteId.fulfilled, (state, action) => {
        if (action.payload) {
          state.propertyMapping[`${action.meta.arg.siteId}`] = {
            ...state.propertyMapping[`${action.meta.arg.siteId}`],
            propertyInfo: action.payload.response,
          };
        }
      })
      .addCase(getMetersByPropertyId.fulfilled, (state, action) => {
        state.propertyMapping[`${action.meta.arg.siteId}`] = {
          ...state.propertyMapping[`${action.meta.arg.siteId}`],
          meters: action.payload.response,
        };
      })
      .addCase(getDatapointsMetersBySiteId.fulfilled, (state, action) => {
        state.propertyMapping[`${action.meta.arg.siteId}`] = {
          ...state.propertyMapping[`${action.meta.arg.siteId}`],
          datapointsMeters: action.payload.response,
        };
      })
      .addCase(getSiteInfo.fulfilled, (state, action) => {
        state.propertyMapping[`${action.meta.arg.siteId}`] = {
          ...state.propertyMapping[`${action.meta.arg.siteId}`],
          siteInfo: action.payload.response,
        };
      })
      .addCase(getPropertyMappingRequests.fulfilled, (state, action) => {
        state.propertyRequests = [...action.payload.response];
      })
      .addCase(getAuditLogBySite.fulfilled, (state, action) => {
        state.propertyMapping[`${action.meta.arg.site_id}`] = {
          ...state.propertyMapping[`${action.meta.arg.site_id}`],
          history: action.payload.response,
        };
      })
      .addCase(getAccountsBySiteId.fulfilled, (state, action) => {
        state.propertyMapping[`${action.meta.arg.site_id}`] = {
          ...state.propertyMapping[`${action.meta.arg.site_id}`],
          accounts: action.payload.response,
        };
      })
      .addCase(getMeterMapping.fulfilled, (state, action) => {
        state.meterMapping = [...action.payload.response];
      });
  },
});

export default slice.reducer;
